import {
  APIServiceConstants,
  BlueprintAPI,
} from '../../redux/actions/BlueprintAPI';

const { SERVICE } = APIServiceConstants;

const disableCloudfrontDistribution = async (customDomainId) => {
  try {
    await BlueprintAPI(SERVICE, `customDomains/${customDomainId}/disable`, {}, null, false, 'PUT');
  } catch (err) {
    throw new Error('Failed to disable Cloudfront Distribution. Please contact Support.');
  }
};

export default disableCloudfrontDistribution;
